// extracted by mini-css-extract-plugin
export default {"SignOutBtn":"SignOutBtn_SignOutBtn__N-YXp","plusIcon":"SignOutBtn_plusIcon__IB5aI"};